import { render, staticRenderFns } from "./VenueWines.vue?vue&type=template&id=3570fa28&scoped=true&"
import script from "./VenueWines.vue?vue&type=script&lang=js&"
export * from "./VenueWines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3570fa28",
  null
  
)

export default component.exports